// PUT all the routes here


// export const CREATE_NEW_BOARD_ROUTE = "/app/new";
// export const CREATE_NEW_BOARD_FROM_TAGS_ROUTE = "/app/new/tags"; // TODO: impl
export const CREATE_NEW_BOARD_FROM_BLOGS_ROUTE = "/app/new/blogs";
// export const UNPUBLISHED_COLLECTIONS_ROUTE = "/app/new/collections/unpublished";
// export const PUBLISHED_COLLECTIONS_ROUTE = "/app/new/collections/published";

export const CREATE_NEW_BOARD_FROM_COLLECTIONS_ROUTE = "/app/new/collections";

export const UNPUBLISH_COLLECTIONS_ROUTE = "/app/goggins/unpublish-collections";

export const EDIT_OR_DELETE_PIN_ROUTE = "/app/goggins/edit-or-delete-pin";


export const HOUSTON_WE_VE_A_PROBLEM_ROUTE = "/app/houston-we-ve-a-problem";

export const ONBOARDING_CONNECT_PINTEREST_ROUTE = "/app/onboarding";


export const PINTEREST_AUTH_CALLBACK_ROUTE = "/auth/pinterest/callback";

export const PINTEREST_AUTH_START_ROUTE = (id: string) => `/auth/pinterest/start/${id}`;


export const PINTEREST_AUTH_START_ROUTE_ON_SERVER = (id: string) => `${process.env.PINTEREST_REDIRECT_BASE_URI}/auth/pinterest/start/${id}`;


export const APP_HOME_ROUTE = "/app";

// Use this only in shopify
export const HOUSTON_WE_VE_A_PROBLEM_ROUTE_WITH_ERROR_MESSAGE = (errorMessage: string) => `${HOUSTON_WE_VE_A_PROBLEM_ROUTE}?errorMessage=${Buffer.from(errorMessage).toString("base64")}`

export const ONBOARDING_CONFIG_ROUTE = "/app/onboarding/config";
export const ONBOARDING_IMPORT_ROUTE = "/app/onboarding/import";
export const ONBOARDING_GEN_BOARDS_ROUTE = "/app/onboarding/gen-boards";
export const ONBOARDING_UPGRADE_ROUTE = "/app/onboarding/upgrade";

export const MANAGE_BOARDS_ROUTE = "/app/boards/all";
export const MANAGE_BOARD_ROUTE = (boardId: string, sourceId: string) => `/app/boards/${sourceId}/${boardId}`;
export const MANAGE_BOARD_PINS_ROUTE = (boardId: string, sourceId: string, type: "published" | "pending" = "pending") => 
  `/app/boards/${sourceId}/${boardId}/pins?type=${type}`;
export const MANAGE_PINTEREST_CONNECTIONS_ROUTE = "/app/manage-pinterest-connections";

export const CREATE_BOARD_API_ROUTE = "/app/goggins/create-board";

export const GET_PINNING_RATE_ROUTE = "/app/goggins/get-pinning-rate";


export const BILLING_ROUTE = "/app/settings/billing";

export const GENERAL_SETTINGS_ROUTE = "/app/settings/general";


export const DELETE_BOARD_ROUTE = "/app/goggins/delete-board";


export const ADD_SCHEDULE_TO_BOARD_ROUTE = (sourceId: string, boardId: string, ruleType: "collection" | "blog" = 'collection') => `/app/boards/${sourceId}/${boardId}/add-schedule?type=${ruleType}`;



export const BULK_CREATE_BOARDS_ROUTE = "/app/boards/bulk-create";



export const PINTEREST_PIN_ROUTE = (pinId: string) => `https://www.pinterest.com/pin/${pinId}`;


export const ALL_RECENT_PINS_ROUTE = "/app/pins/recent";
export const ALL_UPCOMING_PINS_ROUTE = "/app/pins/upcoming";


export const GET_PINTEREST_PIN_ROUTE = (pinId: string) => `https://www.pinterest.com/pin/${pinId}`;


export const START_ONBOARDING_MAIN = (plan?: string, duration?: 'monthly' | 'yearly') => `/onboarding?` + (plan ? `plan=${plan}` : '') + (duration ? `&duration=${duration}` : '')